import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTwitter, faTiktok, faInstagram, faReddit, faYoutube, faBluesky} from '@fortawesome/free-brands-svg-icons';
import { faX, faGift } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-regular-svg-icons';

import "../style/Footer.css"
import { useTranslation } from 'react-i18next';
import { addEmailToSubscription } from '../controllers/MailController';

const Footer = () => {
    const { t, i18n } = useTranslation();

    const [email, setEmail] = React.useState("");
    const [messageNewsletter, setMessageNewsletter] = React.useState("");

    const resetNewsletterMessage = () => {
        setMessageNewsletter("");
    }

    const handleSubscribe = async () => {
        if (!email) return;
        try {
            const result = await addEmailToSubscription(email);
            if (!result)
                setMessageNewsletter("failed")
            else 
                setMessageNewsletter("success")
            setEmail("");
        } catch (error) {
            setMessageNewsletter("error");
        }
    };

    return (
        <footer>
            <div class="footer-container">
                <div class="footer-section">
                    <h4>{t('footer.getToKnowUs')}</h4>
                    <Link class="footer-link" to="/About">{t('footer.aboutUs')}</Link>
                    <Link class="footer-link" to="/why-choose-us">{t('footer.ourSilicone')}</Link>
                    <Link class="footer-link" to="/softness-guide">{t('footer.softnessGuide')}</Link>
                    <Link class="footer-link" to="/care-guide">{t('footer.careGuide')}</Link>
                </div>
                <div class="footer-section footer-section-center">
                    <h4>{t('footer.subscribeText')}</h4>
                    <label class="subscribe-funny">{t('footer.subscribeFunny')}</label>
                    <div className='newsletter-container'>
                        {messageNewsletter ? 
                        <div class="mailing-response-container">
                            {messageNewsletter && 
                                <p className="newsletter-message">
                                    {messageNewsletter === "success"
                                        ? t('footer.newsletterConfirm')
                                        : messageNewsletter === "failed"
                                        ? t('footer.newsletterFailed')
                                        : messageNewsletter === "error"
                                        ? t('footer.newsletterError')
                                        : messageNewsletter}
                                </p>
                            }
                            {messageNewsletter !== "success" &&
                                <FontAwesomeIcon
                                    className="footer-close-button"
                                    icon={faX}
                                    onClick={resetNewsletterMessage}
                                />
                            }
                        </div> 
                        : 
                        <div class="search-container">
                            <input
                                class="footer-email"
                                type="text"
                                placeholder={t('footer.emailPlaceholder')}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                            <button class="footer-search-button" onClick={handleSubscribe}>
                                {t('footer.subscribe')}
                            </button>
                            
                        </div> 
                        }
                    </div>
                    
                    <h4>{t('footer.fillSurvey')}</h4>
                    <div>
                        <Link to="https://forms.office.com/r/xU4jGn9WvE" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faClipboard} color="black"/>
                        </Link>
                    </div>

                    <h4>{t('footer.followUs')}</h4>
                    <div>
                        <Link to="https://twitter.com/AwootoysInc" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faTwitter} color="black" />
                        </Link>
                        <Link to="https://www.tiktok.com/@awootoys" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faTiktok} color="black" />
                        </Link>
                        <Link to="https://www.instagram.com/awootoysinc/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faInstagram} color="black" />
                        </Link>
                        {/* <Link to="https://www.reddit.com/r/Awootoys/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faReddit} color="black" />
                        </Link> */}
                        <Link to="https://www.youtube.com/@awootoys" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faYoutube} color="black" />
                        </Link>
                        <Link to="https://bsky.app/profile/awootoys.com" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon class="social-media-icon" icon={faBluesky} color="black" />
                        </Link>
                    </div>
                    <p className="footer-copyright">Copyright © 2026 Awootoys</p>
                </div>
                <div class="footer-section">
                    <h4>{t('footer.about')}</h4>
                    <Link class="footer-link" to="/Contact">{t('footer.contactUs')}</Link>
                    <Link class="footer-link" to="/privacy-policy">{t('footer.privacyPolicy')}</Link>
                    <Link class="footer-link" to="/terms-of-sale">{t('footer.termsOfSale')}</Link>
                    <Link class="footer-link" to="/terms-of-service">{t('footer.termsOfService')}</Link>
                    <Link class="footer-link" to="/retailers">{t('footer.retailers')}</Link>
                    {/* <Link class="footer-link" to="/media">Press and media</Link> */}
                </div>
            </div>
        </footer>
    );
  };

export default Footer;